const DOT_CODE = "Period";
const ENTER_CODE = "Enter";
const ESCAPE_CODE = "Escape";
const SEMICOLON_CODE = "Semicolon";

export { DOT_CODE, ENTER_CODE, ESCAPE_CODE, SEMICOLON_CODE };
